const PAUSED_CLASS = 'video-is-paused';

/**
 * Handles play/pause functionality for inline videos.
 */
class Video {
  constructor(element) {
    this.element = element;
    this.video = this.element.querySelector('video');
    this.button = this.element.querySelector('.video-pause-button');

    if (!this.video || !this.button) {
      return;
    }

    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.togglePlay = this.togglePlay.bind(this);
    this.connect();
  }

  connect() {
    if (this.prefersReducedMotion) {
      this.pause();
    }
    this.button.addEventListener('click', this.togglePlay);
  }

  disconnect() {
    this.button.removeEventListener('click', this.togglePlay);
  }

  togglePlay() {
    if (this.video.paused) {
      this.play();
    } else {
      this.pause();
    }
  }

  pause() {
    this.button.setAttribute('aria-label', 'Play');
    this.video.pause();
    this.element.classList.add(PAUSED_CLASS);
  }

  play() {
    this.button.setAttribute('aria-label', 'Pause');
    this.video.play();
    this.element.classList.remove(PAUSED_CLASS);
  }
}

export default Video; 